import {
  DebouncedTextInput,
  Group,
  GroupItem,
  useFieldLabel,
  useTabVisibility,
} from "ra-friendsofbabba";

import DateTimeInput from "../../component/input/DateTimeInput";
import React from "react";
import VerificationDocMediaInput from "../inputs/VerificationDocMediaInput";
import { url } from "../../utils/validation";

const VerificationField = ({ tab = 6, ...props }) => {
  const visible = useTabVisibility(tab);
  const fieldLabel = useFieldLabel({ resource: "technical-reports" });
  if (!visible) {
    return null;
  }

  return (
    <Group wrapper fullWidth disabled={props?.disabled}>
      <Group>
        <GroupItem lg={6} md={8} sm={9} xs={12}>
          <DateTimeInput
            source="verification_date"
            label={fieldLabel("verification_date")}
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={12} md={12} sm={12}>
          <DebouncedTextInput
            source="verification_link"
            maxLength={1000}
            validate={url}
            label={fieldLabel("verification_link")}
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={6} md={6} sm={12}>
          <DebouncedTextInput
            source="verification_username"
            maxLength={100}
            label={fieldLabel("verification_username")}
          />
        </GroupItem>
        <GroupItem lg={6} md={6} sm={12}>
          <DebouncedTextInput
            source="verification_password"
            maxLength={100}
            label={fieldLabel("verification_password")}
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={12} md={12} sm={12}>
          <VerificationDocMediaInput
            {...props}
            source="verification_doc_media"
          />
        </GroupItem>
      </Group>
    </Group>
  );
};
export default VerificationField;
